(ns pfo.comment.component
  (:require [reagent.core :as reagent :refer [atom]]
            [clojure.string :as str]
            [pfo.widget.editor :refer [editor]]
            [pfo.widget.toggler :refer [toggler]]
            [pfo.auth.model :as auth-model]
            [pfo.api :as api :refer [process-error]]
            [promesa.core :as p]
            [pfo.tz :as tz]
            [pfo.form :refer [set-checked checked?]]
            [pfo.comment.model :as model]
            [pfo.time :refer [now time-shift-millis instance-start-time]]
            [cljs-time.core :as time-core :refer [minutes seconds before? plus in-seconds
                                                  in-minutes in-seconds interval after?]]
            [pfo.util :as util]
            [pfo.widget.autocomplete :refer [react-select-styles]]
            ["react-select" :default Select]
            [pfo.common.component :as common]))

(declare comment-edit comment-details comment-delete comment-delete-and-revise comment-notify-users timer-fn seconds-left contacts-datalist
         contacts-autocomplete contacts-autocomplete-new)

(def catom clojure.core/atom)
(def comment-max-manage-age (minutes 15))

(defn comment-box [_ body details render-html [note? private? signature? from-inbox?]]
  [:div.c-conversations__comment.o-media--medium  {:class (apply util/classes [(cond note? :is-note private? :is-private from-inbox? :is-from-inbox)
                                                                               (when signature? :is-signature)])}

   (when details
     [:div.c-conversations__comment-detail details])
   [:div.ql-editor.c-string-field

    (if render-html
      (util/html-elem :p body)
      [:p body])]])

(defn notification-user-ids [acomment cc?]
  (for [{:keys [UserID cc]} (:notifications acomment)
        :when (= cc cc?)]
    UserID))

(defn revise-cancel-confirmation [options]
  [:div
   [:h4.u-margin-bottom "Are you sure you want to cancel this revision?"]
   [:span
    [:button {:type :submit
              :on-click (fn []
                          ((:cancel-revision-func-with-reload options))
                          (common/hide-modal :comment-revise-confirmation-modal))}
     "Yes, cancel revision"] " "
    [:button {:on-click #(common/hide-modal :comment-revise-confirmation-modal)} "No, continue editing"]]])

(defn comment-item [_ options acomment _ _]
  (let [elem-node (atom nil)
        highlight? (= (:highlight-comment-id options) (:id acomment))]
    (reagent/create-class
     {:display-name "comment-item"
      :reagent-render (fn [edit-mode options acomment conversation current-user-id]
                        (let [options (merge options {:cancel-func (util/handler #(reset! edit-mode {:type nil}))})]
                          [:div.comment-item {:ref #(reset! elem-node %)
                                              :class (when highlight? "is-highlighted")}
                           (case @edit-mode
                             {:type :comment-revise
                              :id (:id acomment)} [comment-edit edit-mode
                                                   (merge options {:notify-cc-users (notification-user-ids acomment true)
                                                                   :notify-to-users (notification-user-ids acomment false)
                                                                   :cancel-func #(common/show-modal :comment-revise-confirmation-modal [revise-cancel-confirmation options] nil)
                                                                   :note-atom (atom (:note acomment))}
                                                          (when (> (count (:comments conversation)) 1) {:conversation-id (:id conversation)}))
                                                   acomment
                                                   conversation]
                             [comment-details edit-mode acomment current-user-id options])]))
      :component-did-mount (fn [_]
                             (when highlight?
                               (-> @elem-node
                                   (.scrollIntoView #js {:behavior "smooth" :block "center"}))))})))


(defn comment-delete [edit-mode options acomment]
  [:div.comment-delete
   [:h4.u-margin-bottom "Delete " (if (:note acomment) "note?" "comment?")]
   [:span
    [:button {:type :submit
              :on-click (util/handler (fn [] (->> ((:delete-func-with-reload options) (:id acomment) nil)
                                                  (p/map (fn [_]
                                                           (reset! edit-mode {:type :details})
                                                           (common/hide-modal :comment-delete-confirmation)))
                                                  (process-error (:errors-atom options)))))}
     "Confirm"] " "
    [:button {:on-click #(common/hide-modal :comment-delete-confirmation)} "Cancel"]]])

(defn comment-delete-and-revise [edit-mode options acomment]
  [:div.comment-delete
   [:h4.u-margin-bottom "Recall and revise this comment?"]
   [:span
    [:button {:type :submit
              :on-click (util/handler (fn []
                                        (reset! edit-mode {:type :comment-revise, :id (:id acomment)})
                                        (common/hide-modal :comment-delete-and-revise-confirmation)))}
     "Confirm"] " "
    [:button {:on-click #(common/hide-modal :comment-delete-and-revise-confirmation)} "Cancel"]]])

(defn countdown-component
  ; https://www.reddit.com/r/Clojurescript/comments/5htkbc/how_to_use_the_withlet_macro_in_reagent_060/
  [creation-time]
  (reagent/with-let [seconds-left (atom (in-seconds (interval (now) (plus creation-time comment-max-manage-age time-shift-millis))))
                     timer-fn     (js/setInterval #(if (> @seconds-left 0)
                                                     (swap! seconds-left dec)
                                                     (js/clearInterval timer-fn))
                                                  1000)]
    [:div.timer
     [:div "Recall or revise available for: " [:label (str (in-minutes (seconds @seconds-left)) ":"
                                                           (if (< (mod @seconds-left 60) 10)
                                                             (str "0" (mod @seconds-left 60))
                                                             (mod @seconds-left 60)))]]]
    (finally (js/clearInterval timer-fn))))

(defn comment-recipients [notifications]
  [:b (str/join ", " (mapv (fn [notification] (auth-model/get-full-name (:user notification))) notifications))])

(defn comment-details [edit-mode acomment current-user-id options]
  (let [creation-time (util/parse-datetime (:created_at acomment))
        updated-time (util/parse-datetime (:updated_at acomment))
        instance-time (instance-start-time)
        can-still-manage? #(or (:note acomment)
                               (and (before? (now) (plus creation-time comment-max-manage-age)) (if instance-time (after? creation-time instance-time) true)
                                    (:last-comment options)
                                    (not (:signature_id acomment))))
        can-still-manage (can-still-manage?)
        private? (not (:include_body acomment))
        has-recipients? (seq (:notifications acomment))
        to-recipients (filterv #(not (:cc %)) (:notifications acomment))
        cc-recipients (filterv #(:cc %) (:notifications acomment))
        from-inbox? (:from_inbox acomment)]
    ;; NOTE(#2884): this used to spawn a 2s js/setInterval on every render that was
    ;; never cleared. The interval was also a no-op (compare-and-set! was passed the
    ;; predicate fn as the new value, so the atom only ever held truthy values), so
    ;; it is removed rather than converted; can-still-manage is now computed per render.
    [comment-box
     ""

     (:body acomment)

     [:div
      (when (and can-still-manage (= current-user-id (get-in acomment [:user :id])))
        [:div.edit-controls.o-margin-elements--xs
         (when-not (:note acomment) [countdown-component creation-time])
         (if (:note acomment)
           [:span
            [:a {:href "#" :on-click (util/handler #(reset! edit-mode {:type :comment-revise, :id (:id acomment)}))} "Edit"] " "
            [:a {:href "#" :on-click (util/handler #(common/show-modal :comment-delete-confirmation [comment-delete edit-mode options acomment] nil))} "Delete"]]
           [:span
            [:a {:href "#" :on-click (util/handler #(common/show-modal :comment-delete-and-revise-confirmation [comment-delete-and-revise edit-mode options acomment] nil))} " Recall & Revise"] " "
            [:a {:href "#" :on-click (util/handler #(common/show-modal :comment-delete-confirmation [comment-delete edit-mode options acomment] nil))} "Recall & Delete"]])])

      [:div.comment-header-info
       [:p.from (when has-recipients? [:label "From: "]) (if (:signature_id acomment)
                                                           [:span "Note sent with Dropbox Sign request"]
                                                           [:span [:b (auth-model/get-full-name (:user acomment))] (when-not has-recipients? " (Noted) ")])]
       (when (and private? has-recipients?) [:b "PRIVATE"])
       [:time [:p (util/date-format-simple (tz/to-browser-time updated-time))] " " [:p (util/date-format-hour-minute (tz/to-browser-time updated-time))]]

       (when (seq to-recipients)
         [:div.notified  [:label "To: "] [comment-recipients to-recipients]])
       (when (seq cc-recipients)
         [:div.cc [:label "CC: "] [comment-recipients cc-recipients]])]]

     true [(not has-recipients?) private? (boolean (:signature_id acomment)) from-inbox?]]))

(defn conversation-list [conversations {:keys [highlight-comment-id] :as options}]
  (let [elem-node (atom nil)
        new-comment-atom (or (:new-comment-atom options) (atom false))
        new-comment? @new-comment-atom
        edit-mode (atom (if new-comment? {:type :conversation-add} {}))
        note (atom false)
        expand (atom (if new-comment?
                       {}
                       (if highlight-comment-id
                         {(:id (first (filter
                                       (fn [con]
                                         (some #(= (:id %) highlight-comment-id) (:comments con)))
                                       conversations))) true}
                         {(:id (first conversations)) true})))
        ;; The atom below is used to tie new-comment-atom and edit-mode to reflect each other
        propagate-state (clojure.core/atom true)]

    (when (:new-comment-atom options)
      (add-watch new-comment-atom :set-edit-mode
                 (fn [_ _ _ new-value]
                   (when @propagate-state
                     (if new-value
                       (reset! edit-mode {:type :conversation-add})
                       (reset! edit-mode {})))))
      (add-watch edit-mode :set-new-comment
                 (fn [_ _ _ new-edit-mode]
                   (reset! propagate-state false)
                   (reset! new-comment-atom (and (:type new-edit-mode) (not= :details (:type new-edit-mode))))
                   (reset! propagate-state true))))

    (reagent/create-class
     {:display-name "conversation-list"

      :component-did-mount (fn [_]
                             (-> @elem-node
                                 (.scrollIntoView #js {:behavior "smooth" :block "center"})))

      :reagent-render (fn [conversations {:keys [show-new-comment-button-atom] :as options}]
                        [:div.c-conversations.o-margin-elements--lg-vertical {:ref #(reset! elem-node %)}
                         (when (= {:type :conversation-add} @edit-mode)
                           [comment-edit edit-mode (merge options {:add-func (fn [& args]
                                                                               (->> (apply (:add-func options) args)
                                                                                    (p/map (fn [response]
                                                                                             ;; This is kind of a hack. We want to expand the new comment,
                                                                                             ;; but the expand state uses conversation IDs. It happens that
                                                                                             ;; the :add-funcs perform conversation loading as the last step,
                                                                                             ;; so the conversation id from the response (available here)
                                                                                             ;; is put to the expand map
                                                                                             (swap! expand merge {(:conversation_id response) true})))))
                                                                   :note-atom note})])
                         (let [current-user-id (api/get-auth-info :user-id)]
                           (doall (for [conv conversations]
                                    (let [expanded (@expand (:id conv))
                                          last-comment-index (dec (count (:comments conv)))]
                                      [:div.c-conversations__conversation.o-media--medium.u-shadow--around.o-collapsable.o-margin-elements--lg-vertical {:key (:id conv)
                                                                                                                                                         :class (when-not expanded "is-collapsed")}

                                       [:h3.u-flex {:on-click (util/handler #(swap! expand conj {(:id conv) (not expanded)}))} (model/conversation-subject conv)
                                        [:span.expand.o-collapsable__expander]]
                                       (when (@expand (:id conv))
                                         [:div.o-margin-elements--lg-vertical
                                          (doall (map-indexed (fn [index acomment]
                                                                ^{:key (str "comment-" (:id acomment) "-" (:updated_at acomment))}
                                                                [comment-item edit-mode (assoc options
                                                                                               :first-comment (zero? index)
                                                                                               :last-comment (= index last-comment-index)) acomment conv current-user-id])
                                                              (:comments conv)))
                                          (if (= {:type :comment-add
                                                  :conv-id (:id conv)}
                                                 (select-keys @edit-mode [:type :conv-id]))
                                            [comment-edit edit-mode (merge options {:conversation-id (:id conv)
                                                                                    :notify-cc-users (for [notification (:notifications (last (:comments conv)))
                                                                                                           :let [user-id (:UserID notification)]
                                                                                                           :when (and (:cc notification)
                                                                                                                      (not (= user-id current-user-id)))]
                                                                                                       user-id)
                                                                                    :notify-to-users (let [users (for [notification (:notifications (last (:comments conv)))
                                                                                                                       :let [user-id (:UserID notification)]
                                                                                                                       :when (and
                                                                                                                              (not (:cc notification))
                                                                                                                              (not (= user-id current-user-id)))]
                                                                                                                   user-id)
                                                                                                           last-creator-id (get-in (last (:comments conv)) [:user :id])]
                                                                                                       (if (= last-creator-id current-user-id)
                                                                                                         users
                                                                                                         (conj users last-creator-id)))
                                                                                    :note-atom note}) nil conv]
                                            (when (= :details (or (:type @edit-mode) :details))
                                              [:button.u-flex.u-flex__element-to-right {:on-click (util/handler (fn []
                                                                                                                  (reset! note (boolean (:note (last (:comments conv)))))
                                                                                                                  (reset! edit-mode {:type :comment-add
                                                                                                                                     :conv-id (:id conv)})))}
                                               "Reply"]))])]))))
                         (when-not (= {:type :conversation-add} @edit-mode)
                           [:div.controls
                            (when (and (:can-add-comment options) @show-new-comment-button-atom)
                              [:button (merge {:on-click (util/handler (fn []
                                                                         (reset! note false)
                                                                         (reset! edit-mode {:type :conversation-add})
                                                                         (reset! new-comment-atom true)))}
                                              (if-not (= :details (or (:type @edit-mode) :details)) {:disabled "disabled"} {})) "Add New Comment"])])])})))

(defn comment-counter [show-count comment-count-atom]
  (when show-count
    [:span.c-counter @comment-count-atom]))

(defn expandable-conversation-list
  [{:keys [highlight-comment-id] :as options}
   load-conversations]

  (let [conversations (atom nil)
        collapsed? (or (options :comments-collapse?) (atom true))
        add-new-comment? (atom false)
        can-add-comment (get-in options [:user-perms :can_comment])
        has-highlighted-comment (atom false)
        load-and-set-conversations (fn [load-fn] (->> (load-fn)
                                                      (p/map (fn [convs]
                                                               (reset! conversations convs)
                                                               (when-not @has-highlighted-comment
                                                                 (reset! has-highlighted-comment
                                                                         (boolean (first (filter
                                                                                          (fn [con]
                                                                                            (some #(= (:id %) highlight-comment-id) (:comments con))) convs))))
                                                                 (when @has-highlighted-comment (reset! collapsed? false)))))
                                                      (process-error)))]
    (when highlight-comment-id (load-and-set-conversations load-conversations))
    (fn [{:keys [reload-cb comment-count update-counter] :as options}
         load-conversations]

      (let [has-comments? (> @comment-count 0)
            more-than-one-comment (> @comment-count 1)

            func-with-reload (fn [func counter-swapper collapse?]
                               (fn [& args]
                                 (->> (apply func args)
                                      (p/map (fn [response]
                                               (swap! comment-count counter-swapper)

                                               (when-let [update-counter update-counter]
                                                 (update-counter counter-swapper))

                                               (reset! add-new-comment? false)
                                               (when collapse? (reset! collapsed? true))

                                               (when reload-cb (reload-cb))
                                               (load-and-set-conversations load-conversations)
                                               response)))))]

        [:div.u-cursor--pointer.expandable-conversation-list
         [:div {:on-click (fn [e]
                            (when (and (not= "comment-add" (.getAttribute (.-target e) "data-origin"))
                                       (not @add-new-comment?))
                              (swap! collapsed? not)
                              (load-and-set-conversations load-conversations)
                              (when-not @collapsed?
                                (reset! add-new-comment? false))))}

          [:h4.c-comments-header.c-heading
           [util/disable-tool {:disabled (and (not can-add-comment) (not has-comments?))
                               :message "You don't have a permission to add a comment"
                               :component [:div.c-comments-header__top
                                           [:span.c-comments-header__img]

                                           (if (and (not @add-new-comment?) has-comments?)
                                             [:span
                                              [:span.comment-counter @comment-count]
                                              [:div.c-comments-header__bottom.o-collapsable {:class (when @collapsed? "is-collapsed")}
                                               [:a.o-collapsable__expander]]]

                                             [:span.comment-add
                                              (when-not @add-new-comment?
                                                [:img.svg-icon--s  {:src "/static/img/icons/item-add.svg"
                                                                    :on-click (fn [_]
                                                                                (load-and-set-conversations load-conversations)
                                                                                (when can-add-comment
                                                                                  (reset! add-new-comment? true))
                                                                                (reset! collapsed? false))
                                                                    :data-origin "comment-add"}])])]}]]]

         (when (and @conversations (not @collapsed?))
           [:div
            [conversation-list @conversations
             (merge
              options
              {:add-func (func-with-reload (:add-func options) inc false)
               :add-revised-func (func-with-reload (:add-func options) identity false)
               :update-func (func-with-reload (:update-func options) identity false)
               :delete-func-with-reload (func-with-reload (:delete-func options) dec false)
               :cancel-revision-func-with-reload (func-with-reload (fn []) dec false)
               :delete-func (:delete-func options)
               :new-comment-atom add-new-comment?
               :can-add-comment can-add-comment
               :show-new-comment-button-atom (atom (seq @conversations))})]])]))))

(defn note-message-toggler [send-message note-atom]
  [:span
   [:span.u-margin-right--xs (when-not @send-message {:class :u-color--primary}) "Add Note"]
   [toggler {:checked send-message
             :flex-direction "row"
             :size "small"
             :on-change (fn [ev]
                          (reset! send-message (checked? ev))
                          (reset! note-atom (not @send-message)))}]
   [:span (when @send-message {:class :u-color--primary}) "Send Message"]])

(defn comment-edit [edit-mode options acomment conversation]
  (let [elem-node (atom nil)
        subject (atom (:subject conversation))
        users-map (into {} (map (fn [user] [(:id user) user]) (:users options)))
        body (atom (or (:body acomment) nil))
        errors (:errors-atom options)
        note-atom (:note-atom options)
        send-message (atom (not @note-atom))
        conversation-id (:conversation-id options)
        notify-users (atom (filterv (fn [user-id] (contains? users-map user-id)) (:notify-to-users options)))
        notify-cc-users (atom
                         (filterv
                          (fn [user-id] (and (contains? users-map user-id) (not (contains? (set @notify-users) user-id))))
                          (:notify-cc-users options)))
        can-notify-with-content (get-in options [:user-perms :can_notify_with_content])
        can-enable-email-reply (get-in options [:user-perms :can_enable_email_reply])
        include-body (atom (not can-notify-with-content))
        allow-inbox-reply (atom false)
        submit (util/handler (if acomment
                               (if (:note acomment)
                                 (fn [] (->>
                                         ((:update-func options) (:id acomment) (when (:first-comment options) @subject) @body [] [] (not @include-body) false)
                                         (p/map #(reset! edit-mode {}))
                                         (process-error errors)))
                                 (fn [] (->> ((:add-revised-func options) conversation conversation-id @note-atom @subject @body
                                                                          (into []  @notify-users) (into [] @notify-cc-users)
                                                                          (not @include-body) @allow-inbox-reply (:id acomment))
                                             (p/map #(reset! edit-mode {}))
                                             (process-error errors))))

                               (fn [] (->> ((:add-func options) conversation conversation-id @note-atom @subject @body
                                                                (into []  @notify-users) (into [] @notify-cc-users)
                                                                (not @include-body) @allow-inbox-reply nil)
                                           (p/map #(reset! edit-mode {}))
                                           (process-error errors)))))]

    (add-watch notify-users :remove-cc-users (fn [_ _ _ new-notify-users]
                                               (when-not (seq new-notify-users)
                                                 (reset! notify-cc-users nil))))

    (reagent/create-class
     {:display-name "comment-edit"

      :component-did-mount (fn [_]
                             (reset! errors {})
                             (-> @elem-node
                                 (.scrollIntoView #js {:behavior "smooth" :block "center"})))

      :reagent-render (fn [edit-mode options acomment conversation]
                        [:form.c-conversations__conversation.o-media--medium.o-margin-elements--md-vertical {:ref #(reset! elem-node %) :on-submit submit}
                         (if-not conversation
                           [:div.fields.o-margin-elements--md-vertical {:class (when @note-atom :note)}
                            [:div.comment-header.u-flex
                             [:h3.u-text-uppercase "New " (if @note-atom "note:" "message:")]
                             [:span.cancel.u-flex__element-to-right {:on-click (util/handler (fn []
                                                                                               (reset! edit-mode {})
                                                                                               (when-let [new-comment-atom (:new-comment-atom options)]
                                                                                                 (reset! new-comment-atom false))))} "X"]]

                            [:div.extra (:extra-edit-new-conversation-components options)]
                            [:label.label-note ""]
                            [:div.note.u-vertical-align--middle 
                             [note-message-toggler send-message note-atom]]
                            
                            (when-not @note-atom
                              [:<>
                               [:label.label-to "To:"]
                               [:> Select
                                (merge
                                 {:options (for [user (:users options) :when (not (contains? (set @notify-cc-users) (:id user)))]
                                             {:label (auth-model/get-full-name user) :value (:id user)})
                                  :isMulti true
                                  :class :to
                                  :placeholder "To"
                                  :on-change (fn [x] (reset! notify-users (map (fn [entity] (-> entity :value)) (js->clj x :keywordize-keys true))))}
                                 (:second react-select-styles))]

                               [:label.label-cc "CC:"]
                               [:div
                                [:> Select
                                 (merge
                                  {:options (for [user (:users options) :when (not (contains? (set @notify-users) (:id user)))]
                                              {:label (auth-model/get-full-name user) :value (:id user)})
                                   :isMulti true
                                   :class :cc
                                   :placeholder "CC"
                                   :isDisabled (not (seq @notify-users))
                                   :on-change (fn [x] (reset! notify-cc-users (map (fn [entity] (-> entity :value)) (js->clj x :keywordize-keys true))))}
                                  (:second react-select-styles))]
                                [:span.error (:notify_cc_user_id @errors)]]])

                            [:label.label-subject "Subject:"]
                            [:input {:type "text"
                                     :value @subject
                                     :on-change (util/reset-from-event subject)}]]

                                        ;Reply
                           [:div.fields.o-margin-elements--md-vertical {:class (when @note-atom :note)}
                            ;; [:span "NTOEATEOM " (str @note-atom)]
                            [:div.comment-header.u-flex
                             [:a.u-flex__element-to-right {:on-click (if (:cancel-func options)
                                                                       (:cancel-func options)
                                                                       (util/handler #(reset! edit-mode {})))} "X"]]
                            [:div.extra]
                            [:label.label-note ""]
                            [:div.note.u-vertical-align--middle
                             (when-not (= :comment-revise (:type @edit-mode))
                               [note-message-toggler send-message note-atom])]
                            (when-not @note-atom
                              [:<>
                               [:label.label-to "To:"]
                               [:> Select
                                (merge
                                 {:options (for [user (:users options) :when (not (contains? (set @notify-cc-users) (:id user)))]
                                             {:label (auth-model/get-full-name user) :value (:id user)})
                                  :isMulti true
                                  :defaultValue (clj->js (for [user-id (:notify-to-users options)
                                                               :let [user (users-map user-id)]
                                                               :when user]
                                                           {:value user-id :label (auth-model/get-full-name (users-map user-id))}))
                                  :class :to
                                  :placeholder "To"
                                  :on-change (fn [x] (reset! notify-users (map (fn [entity] (-> entity :value)) (js->clj x :keywordize-keys true))))}
                                 (:second react-select-styles))]

                               [:label.label-cc "CC:"]
                               [:div
                                [:> Select
                                 (merge
                                  {:options (for [user (:users options) :when (not (contains? (set @notify-users) (:id user)))]
                                              {:label (auth-model/get-full-name user) :value (:id user)})
                                   :isMulti true
                                   :defaultValue (clj->js (for [user-id (:notify-cc-users options)
                                                                :let [user (users-map user-id)]
                                                                :when (and user (not (contains? (set @notify-users) (:id user))))]
                                                            {:value user-id :label (auth-model/get-full-name (users-map user-id))}))
                                   :class :cc
                                   :placeholder "CC"
                                   :isDisabled (not (seq @notify-users))
                                   :on-change (fn [x] (reset! notify-cc-users (map (fn [entity] (-> entity :value)) (js->clj x :keywordize-keys true))))}
                                  (:second react-select-styles))]
                                [:span.error (:notify_cc_user_id @errors)]]])

                            (when (:first-comment options)
                              [:label.label-subject "Subject:"])
                            (when (:first-comment options)
                              [:input {:type "text"
                                       :value @subject
                                       :on-change (util/reset-from-event subject)}])])

                         [:div.editor-field
                          (if (:rich-text options)
                            [editor nil body]
                            [:textarea {:value @body
                                        :on-change (util/reset-from-event body)}])
                          [:span.error (:body @errors)]
                          (when-not @note-atom
                            (when (and include-body (seq @notify-users))
                              [:div.o-in
                               [:div.u-flex
                                [:label.u-flex__element-to-left
                                 [:input (merge
                                          (set-checked @include-body {:on-click #(do
                                                                                   (reset! include-body (-> % .-target .-checked))
                                                                                   (reset! allow-inbox-reply (not include-body)))})
                                          (when-not can-notify-with-content
                                            {:disabled true}))]
                                 "Send secure"]]

                               (when (and (not @include-body) can-enable-email-reply)
                                 [:div.u-flex
                                  [:label.u-flex__element-to-left
                                   [:input (merge
                                            (set-checked @allow-inbox-reply {:on-click #(reset! allow-inbox-reply (-> % .-target .-checked))}))]
                                   "Allow reply from email inbox"]])]))]

                         (if acomment
                           [:div.o-flex-align--right.o-margin-elements--xs
                            [:button {:type :button :on-click submit} "Save"]
                            [:button {:type :button :on-click (:cancel-func options)} "Cancel"]]
                           [:button.u-flex.u-flex__element-to-right {:type :submit}
                            (if conversation-id
                              "Reply"
                              (if (seq @notify-users) "Send" "Post"))])])})))

(defn comment-notify-users [_ _ _]
  (let [notify-users-expaneded (atom false)]
    (fn [options notify-users include-body]
      (let [notify-user-choices (:users options)]
        (when (seq notify-user-choices)
          [:div.expander.notify-users
           [:a.expander-trigger (merge (if @notify-users-expaneded {} {:class "expander-hidden"})
                                       {:on-click (util/handler #(swap! notify-users-expaneded not))})
            "Notify users"]
           [:div.expander-content
            (when (and include-body (seq @notify-users))
              [:p [:label
                   [:input (set-checked @include-body {:on-click #(reset! include-body (-> % .-target .-checked))})]
                   "Include comment content in emails"]])
            [:ul.users
             (doall
              (for [auser notify-user-choices]
                (let [user-id (:id auser)]
                  [:li {:key (:id auser)}
                   [:label
                    [:input (set-checked
                             (contains? @notify-users user-id)
                             {:on-click (fn [ev]
                                          (let [selected (-> ev .-target .-checked)]
                                            (if selected
                                              (swap! notify-users conj user-id)
                                              (swap! notify-users disj user-id))))})]
                    (auth-model/get-full-name auser)]])))]]])))))

(defn comments-summary [summary]

  (when summary
    [:ul.comments-summary
     (doall
      (for [summary-item summary]
        [:li {:key (:comment_id summary-item)}
         (:user_first_name summary-item)
         (case (:type summary-item)
           0 " added a comment"
           1 " replied to a comment"
           2 " added a note")]))]))
